/**
 * Sends a message to the VoiceBot via CustomEvent.
 * The CES voice assistant client listens for '__vb_send' to receive messages.
 * @param {string} message - The text message to send to VoiceBot
 */
export const sendVoiceBotMessage = (message) => {
    if (typeof window !== 'undefined') {
      document.dispatchEvent(
        new CustomEvent('__vb_send', {
          detail: { text: message },
        })
      );
    }
  };
  